<template>
  <div class="teaching-evaluate-apply-define">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridCascade :visible.sync="visible"
                     content="课程评教内容自定义设置"
                     decorator="nav-bar">
      <TeachingEvaluateApplyDefineMain v-bind="$attrs"></TeachingEvaluateApplyDefineMain>
    </DataGridCascade>
  </div>
</template>

<script>
import DataGridCascade from '../../../../../../../elements/grid/DataGridCascade'
import TeachingEvaluateApplyDefineMain from './main'
export default {
  name: 'TeachingEvaluateApplyDefine',
  components: {
    DataGridCascade,
    TeachingEvaluateApplyDefineMain
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-define {
    display: inline-block;
  }
</style>
